import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import BoxStatistical from '@/components/Statistical/BoxStatistical'
import { getInvoicesStatistical } from '@/modules/Invoice/services'
import { formatCurrency } from '@/utils/function'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface StatisticalProps {
    params: DataGridPayload
}

const Statistical: React.FC<StatisticalProps> = ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { page, page_size, ...rest } = params
    const { data, renderState, isFetching } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.INVOICES_STATISTICAL, { ...rest }],
        queryFn: () => getInvoicesStatistical(rest),
    })

    const dataStatistical = [
        {
            label: 'total',
            count: data?.results?.reduce(
                (sum, item) => sum + (item?.count || 0),
                0
            ),
            value: data?.results?.reduce(
                (sum, item) => sum + (item?.total_amount || 0),
                0
            ),
        },
        {
            label: 'total-paid',
            count: data?.results
                ?.filter((item) => {
                    return ['paid', 'done'].includes(item?.invoice_status)
                })
                ?.reduce((sum, item) => sum + (item?.count || 0), 0),
            value: data?.results
                ?.filter((item) => {
                    return ['paid', 'done'].includes(item?.invoice_status)
                })
                ?.reduce((sum, item) => sum + (item?.total_amount || 0), 0),
        },
        {
            label: 'total-not-paid',
            count: data?.results
                ?.filter((item) => {
                    return ['waiting-confirm', 'approved'].includes(
                        item?.invoice_status
                    )
                })
                ?.reduce((sum, item) => sum + (item?.count || 0), 0),
            value: data?.results
                ?.filter((item) => {
                    return ['waiting-confirm', 'approved'].includes(
                        item?.invoice_status
                    )
                })
                ?.reduce((sum, item) => sum + (item?.total_amount || 0), 0),
        },
        {
            label: 'debt',
            count: data?.results
                ?.filter((item) => {
                    return (
                        ['waiting-confirm', 'approved'].includes(
                            item?.invoice_status
                        ) && item?.revenue_confirmed
                    )
                })
                ?.reduce((sum, item) => sum + (item?.count || 0), 0),
            value: data?.results
                ?.filter((item) => {
                    return (
                        ['waiting-confirm', 'approved'].includes(
                            item?.invoice_status
                        ) && item?.revenue_confirmed
                    )
                })
                ?.reduce((sum, item) => sum + (item?.total_amount || 0), 0),
        },
        {
            label: 'total-cancalled',
            count: data?.results
                ?.filter((item) => {
                    return ['cancelled'].includes(item?.invoice_status)
                })
                ?.reduce((sum, item) => sum + (item?.count || 0), 0),
            value: data?.results
                ?.filter((item) => {
                    return ['cancelled'].includes(item?.invoice_status)
                })
                ?.reduce((sum, item) => sum + (item?.total_amount || 0), 0),
        },
    ]

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <div className="grid lg:grid-cols-5 md:grid-cols-3 grid-cols-1 gap-4">
            {dataStatistical?.map((i) => {
                return (
                    <BoxStatistical
                        label={i?.label}
                        count={i?.count}
                        helperText={`${i.label}-description`}
                        loading={isFetching}
                    >
                        {formatCurrency(i.value || 0)}
                    </BoxStatistical>
                )
            })}
        </div>
    )
}

export default Statistical
